export {}

declare global {
    interface String {
        capitalize(): string;
    }
}

if (!String.prototype.capitalize) {
    String.prototype.capitalize = function (this: string): string {
        if (this?.length === 0) {
            return this;
        }
        return this.charAt(0).toUpperCase() + this.slice(1);
    }
}
